export const conditionalItem = <T>(condition: boolean, item: T): T[] => {
  if (condition) {
    return [item];
  }

  return [];
};
